import styled from 'styled-components';
var Variants;
(function (Variants) {
    Variants["default"] = "#F5F5F5";
    Variants["warning"] = "#FFFFB5";
})(Variants || (Variants = {}));
export const List = styled.ul `
  position: relative;
`;
export const Header = styled.div `
  width: 100%;
  background-color: ${(props) => Variants[props.variant]};
  position: sticky;
  top: 0;
  z-index: 1;
`;
export const ListItemWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border-top: 1px solid #E2E2E2;
  gap: 15px;
`;
export const ActionButton = styled.button `
  height: 35px;
  width: 35px;
  background: none;
  border: none;
  cursor: pointer;
`;
//# sourceMappingURL=styles.js.map